import hotkeysMapping from 'constants/hotkeysMapping';

const displayCombination = combination =>
  combination.map(c => (hotkeysMapping[c] ? hotkeysMapping[c] : c)).join(' + ');

export default displayCombination;
